import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { AircraftBillingRateAudit } from '../../+models/aircraft-profile-audit.model';

@Component({
  selector: 'sd-portal-aircraft-billing-rate-audit-list',
  templateUrl: './aircraft-billing-rate-audit-list.component.html',
  styleUrls: ['./aircraft-billing-rate-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AircraftBillingRateAuditListComponent implements OnInit {
  @Input() aircraftBillingRateId: number;
  @Input() loading: boolean;
  @Input() aircraftBillingRateAudits: AircraftBillingRateAudit[];

  @Output() loadAircraftBillingRate = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadAircraftBillingRate.emit(this.aircraftBillingRateId);
  }

  onNextPage() {
    this.nextPage.emit(this.aircraftBillingRateId);
  }
}
